export default __webpack_public_path__ + "static/media/cuttingMachines.bba828b7.webp";